// extracted by css-extract-rspack-plugin
export default {"cls1":"SubtopicsBar-cls1_OQ0","cls2":"SubtopicsBar-cls2_9mX SubtopicsBar-cls1_OQ0","selected":"SubtopicsBar-selected_5Bu"};